import { ADD_SENTRY_ERROR } from "./actionTypes";

export default ({error, eventId}) => ({
  type: ADD_SENTRY_ERROR,
  payload: {
    error,
    eventId
  },
});